import { Button } from '@/components/ui/button';

import { Hint } from './Hint';

/** Previous and Next buttons for the files of the list the person came from, pinned under a file editor. */
export function FileNavBar({
    listName,
    onPrevious,
    onNext,
}: {
    listName: string;
    /** Opens the previous file (P); unset when there is none. */
    onPrevious?: () => void;
    /** Opens the next file (N); unset when there is none. */
    onNext?: () => void;
}) {
    return (
        <div
            className="flex shrink-0 flex-wrap items-center justify-between gap-2 border-t px-4 py-3"
            data-testid="FileNavBar"
        >
            <Hint
                text={`Previous file in ${listName}  (P)`}
                focusable={onPrevious === undefined}
            >
                <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    className="whitespace-nowrap"
                    disabled={onPrevious === undefined}
                    onClick={onPrevious}
                    aria-label={`Previous in ${listName}`}
                    data-testid="FileNavBar__previous"
                >
                    ← Previous
                </Button>
            </Hint>
            <Hint
                text={`Next file in ${listName}  (N)`}
                focusable={onNext === undefined}
            >
                <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    className="whitespace-nowrap"
                    disabled={onNext === undefined}
                    onClick={onNext}
                    aria-label={`Next in ${listName}`}
                    data-testid="FileNavBar__next"
                >
                    Next →
                </Button>
            </Hint>
        </div>
    );
}
